const ProductRecommendationTypes = {
  Favorites: "favorites",
  PastPurchases: "past-purchases",
} as const;

export type ProductRecommendationType =
  (typeof ProductRecommendationTypes)[keyof typeof ProductRecommendationTypes];

export const ProductRecommendationLabels = Object.freeze({
  [ProductRecommendationTypes.Favorites]: "Favorites",
  [ProductRecommendationTypes.PastPurchases]: "Past Purchases",
});

export default ProductRecommendationTypes;
